import React from "react";
import About from "./components/About";
import HeaderVideoSection from "./components/HeaderVideoSection";
import Roadmap from "./components/Roadmap";
import Team from "./components/Team";
import "./App.css";

function App() {
  return (
    <React.Fragment>
      <HeaderVideoSection />
      <About />
      <Roadmap />
      <Team />
    </React.Fragment>
  );
}

export default App;
